import React from "react";
import { Link } from "react-router-dom";
import "./AllSolProducts.css";

import icon1 from "../../../../assets/images/allsolutions/p1.svg";
import icon2 from "../../../../assets/images/allsolutions/p2.svg";
import icon3 from "../../../../assets/images/allsolutions/p3.svg";
import icon4 from "../../../../assets/images/allsolutions/p4.svg";

const products = [
    {
        title: "Boards",
        description:
            "Water-resistant core withstands exposure before cladding is fixed",
        icon: icon1,
        to: "/products/boards",
    },
    {
        title: "Drywall metal frame",
        description:
            "Glass mat facing resists ignition and slows flame spread",
        icon: icon2,
        to: "/products/drywall-metal-frame",
    },
    {
        title: "Ceiling metal frame",
        description:
            "Adds racking strength and rigidity to the external frame",
        icon: icon3,
        to: "/products/ceiling-metal-frame",
    },
    {
        title: "Accessories",
        description:
            "Water-resistant core withstands exposure before cladding is fixed",
        icon: icon4,
        to: "/accessories",
    },
];

const AllSolProducts = () => {
    return (
        <section className="allsolProd-section" aria-labelledby="allsolProd-heading">
            <div className="allsolProd-inner">
                <div className="allsolProd-header">
                    <span className="allsolProd-badge">OUR PRODUCTS</span>

                    <h2 id="allsolProd-heading" className="allsolProd-heading">
                        <span className="allsolProd-headingLine">Explore product categories</span>
                        <br />
                        <span className="allsolProd-headingSub">within our solutions</span>
                    </h2>

                    <div className="allsolProd-headerRule" aria-hidden="true" />
                </div>

                <div className="allsolProd-grid">
                    {products.map((item) => (
                        <Link
                            className="allsolProd-card"
                            key={item.title}
                            to={item.to}
                            aria-label={`Explore ${item.title}`}
                        >
                            <div className="allsolProd-icon">
                                {item.icon && (
                                    <img src={item.icon} alt="" draggable={false} />
                                )}
                            </div>
                            <div>
                                <h3 className="allsolProd-cardTitle">{item.title}</h3>
                                <p className="allsolProd-cardDesc">{item.description}</p>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AllSolProducts;
